<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="$readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <InputNumber
      style="width: 100%;"
      :value="value"
      :placeholder="label"
      :readonly="$readonly"
      :disabled="disabled"
      :clearable="clearable"
      :step="step"
      :size="$size"
      :editable="editable"
      :max="max"
      :min="min"
      @on-change="onInputChange"
    />
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'

export default {
  name: 'zpaNumberInput',

  mixins: [inputMixin],

  data() {
    return {
      type: 'number',
      default: '',
    }
  },

  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },

    step: Number,

    editable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
